export const getVariableName = (name: string, prefix?: string) => {
  return prefix ? `--${prefix}-${name}` : `--${name}`;
};
